import { EVENTS } from "./events";

export const emitKeyDown = (key: string) => {
  const pianoEvent = new CustomEvent(EVENTS.PIANO_KEY_DOWN, { detail: key });
  window.dispatchEvent(pianoEvent);
}

export const emitKeyUp = (key: string) => {
  const pianoEvent = new CustomEvent(EVENTS.PIANO_KEY_UP, { detail: key });
  window.dispatchEvent(pianoEvent);
}